import { fetchActivityCountApi } from "../../../../network/service";
import {
  fetchLeadIdFromURL,
  getUserStandardTimeZone,
} from "../../../../utils/helpers";

const getActivityType = (config) => {
  const activityType = config?.activityTypes?.[0]?.id;
  if (activityType !== "select_all") {
    return activityType;
  }
  return null;
};
const fetchActivityCount = async (config) => {
  try {
    const body = {
      PageIndex: 1,
      PageSize: 1,
      Columns:
        "LeadIdentifier,ActivityEvent_Note,PACreatedOn,Owner,Status,P_ProspectStage,P_mx_City,P_PhotoUrl,P_mx_State,P_mx_Country,P_DoNotEmail,P_DoNotCall",
      SearchText: "",
      IsOpportunity: false,
      SortOn: "ModifiedOn",
      SortBy: 1,
    };
    const activityType = getActivityType(config);
    if (activityType) {
      body.Code = activityType;
    }
    const customFilters = {
      GrpConOp: "and",
      QueryTimeZone: getUserStandardTimeZone(),
      Conditions: [],
    };
    body.CustomFilters = JSON.stringify(customFilters);
    const advancedSearch = {
      GrpConOp: "And",
      Conditions: [
        {
          Type: "Activity",
          ConOp: "and",
          RowCondition: [
            activityType !== "select_all" && {
              SubConOp: "And",
              LSO: "ActivityEvent",
              LSO_Type: "PAEvent",
              Operator: "eq",
              RSO_IsMailMerged: false,
              RSO: activityType,
            },
            {
              SubConOp: "And",
              LSO_Type: "DateTime",
              LSO: "ActivityTime",
              Operator: "eq",
              RSO: config?.dateFilters?.id,
            },
          ].filter(Boolean),
        },
        {
          Type: "Lead",
          ConOp: "and",
          RowCondition: [
            {
              SubConOp: "And",
              LSO: "ProspectID",
              LSO_Type: "String",
              Operator: "eq",
              RSO_IsMailMerged: false,
              RSO: fetchLeadIdFromURL(),
            },
            {
              RSO: "",
            },
          ],
        },
      ],
      QueryTimeZone: "India Standard Time",
    };
    body.AdvancedSearch = JSON.stringify(advancedSearch);
    const response = await fetchActivityCountApi(body);
    if (response.status !== 200)
      throw new Error("Failed to fetch activity count");
    return response.data?.RecordCount;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default fetchActivityCount;
